<template>
  <div class="v-header">
    <van-nav-bar :title="headerTitle" fixed :border='false' :left-arrow="isShowArrow" left-text=""
      @click-left="backToPrev">
      <!-- <van-icon name="calender-o" slot="right" v-show="isShowIcon" @click="showDate"/> -->
      <!--   <van-icon name="filter-o" slot="right" v-show="isShowIcon || isShowFilter" @click="toggleFilter"/> -->
      <!--    <van-icon name="calender-o" slot="right" v-show="isShowIcon" @click="toggleCalendar"/> -->
      <van-icon name="ellipsis" slot="right" v-show="isShowIcon" />
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: 'v-header',
  props: {
    headerTitle: {
      type: String,
      default: ''
    },
    isShowIcon: {
      type: Boolean,
      default: false
    },
    isShowArrow: {
      type: Boolean,
      default: true
    },
    isShowFilter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    backToPrev() {
      this.$router.go(-1)
    },
    showDate() {
      this.$emit('showDate')
    },
    toggleFilter() {
      this.$emit('toggleFilter')
    },
    toggleCalendar() {
      this.$emit('toggleCalendar')
    }
  }
}
</script>
<style lang="less" scoped>
.v-header {
  height: 46px;

  ::v-deep {
    .van-hairline--bottom {
      &::after {
        border-color: #e1e1e1;
      }
    }
    .van-nav-bar__title{
      font-size: 18px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.9);
    }
    .van-nav-bar {
      // border-bottom: 1px solid #f0f0f0;
      z-index: 100;

      .van-nav-bar__left {
        .van-icon {
          color: rgba(0, 0, 0, 0.9);
          font-size: 18px;
        }
      }

      .van-nav-bar__right {
        .van-icon {
          color: rgba(0, 0, 0, 0.9);
          font-size: 20px;
        }

        .van-icon-filter-o {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
